<div class='col-setting'>
    <img class="settings-logo" src="./../../../assets/images/ic-settings-inactive.png" (click)="toggleDropdown()" alt="">
    <p-multiSelect #multiSelect [options]="tableOptions" class="setting" (onChange)="onChange($event)" [(ngModel)]="selected" appendTo="body"></p-multiSelect>
</div>